<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
    :withFooter="withFooter"
  >
    <el-form :model="form" ref="form" :rules="withFooter ? rules : null" :disabled="!withFooter">
      <el-row :gutter="10">
        <el-col :span="8"><el-form-item label="部门名称" prop="deptName">
          <el-input v-model="form.deptName" :placeholder="!withFooter?null:'请输入部门名称'" v-trim/>
        </el-form-item></el-col>
        <el-col :span="8"><el-form-item label="模版名称" prop="templateName">
          <el-input v-model="form.templateName" :placeholder="!withFooter?null:'请输入模版名称'" v-trim/>
        </el-form-item></el-col>
        <el-col :span="8"><el-form-item label="模版类型" prop="templateType">
          <DictDataSelect
            code="template_type"
            v-model="form.templateType"
            placeholder="请选择模版类型"
            clearable
          >
          </DictDataSelect>
        </el-form-item></el-col>
        <el-col :span="8"><el-form-item label="批次" prop="matVo.pc">
          <el-input v-model="form.matVo.pc" :placeholder="!withFooter?null:'请输入批次'" v-trim/>
        </el-form-item></el-col>
        <el-col :span="8"><el-form-item label="物料编码" prop="matVo.wlbm">
          <el-input v-model="form.matVo.wlbm" :placeholder="!withFooter?null:'请输入物料编码'" v-trim/>
        </el-form-item></el-col>
        <el-col :span="8"><el-form-item label="数据主体" prop="dataType">
          <DictDataSelect
            code="data_type"
            v-model="form.dataType"
            placeholder="请选择数据主体"
            clearable
          >
          </DictDataSelect>
        </el-form-item></el-col>
        <el-col :span="8"><el-form-item label="标签打印数量" prop="copies">
          <el-input v-model="form.copies" :placeholder="!withFooter?null:'请输入标签打印数量'" v-trim/>
        </el-form-item></el-col>
        <el-col :span="8"><el-form-item label="打印人名称" prop="createUserName">
          <el-input v-model="form.createUserName" :placeholder="!withFooter?null:'请输入打印人名称'" v-trim/>
        </el-form-item></el-col>
        <el-col :span="8"><el-form-item label="打印时间" prop="createTime">
          <el-input v-model="form.createTime" :placeholder="!withFooter?null:'请输入打印时间'" v-trim/>
        </el-form-item></el-col>
      </el-row>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'InventoryRecordOperaWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        matVo:{
          pc:"",
          wlbm:"",
        },
        deptName:"",
        templateName:"",
        templateType:"",
        createTimeEnd: "",
        createTime: "",
        createUserName: null,
        data: "",
        dataId: null,
        dataType: "",
        id: null,
        copies: null,
      },
      // 验证规则
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称' }
        ],
        templateName: [
          { required: true, message: '请输入模版名称' }
        ],
        templateType: [
          { required: true, message: '请输入模版类型' }
        ],
        'matVo.pc': [
          { required: true, message: '请输入批次' }
        ],
        'matVo.wlbm': [
          { required: true, message: '请输入物料编码' }
        ],
        dataType: [
          { required: true, message: '请输入数据主体' }
        ],
        copies: [
          { required: true, message: '请输入标签打印数量' }
        ],
        createUserName: [
          { required: true, message: '请输入打印人名称' }
        ],
        createTime: [
          { required: true, message: '请输入打印时间' }
        ],
      }
    }
  },
  methods: {
    /**
     * 打开窗口
     *
     * @param title 窗口标题
     * @param target 行对象（仅编辑需该参数）
     */
    open(title, target, withFooter = true) {
      this.withFooter = withFooter;
      this.title = title;
      this.visible = true;
      // 新建
      if (target == null) {
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.form.id = null;
        });
        return;
      }
      // 编辑
      this.$nextTick(() => {
        for (const key in this.form) {
          this.form[key] = target[key];
        }
      });
    },
  },
  created () {
    this.config({
      api: '/print_logging',
      'field.id': 'id'
    })
  }
}
</script>
<style lang='scss' scoped>
.el-input.is-disabled /deep/ .el-input__inner {
  color: rgba(0, 0, 0, 0.672);
  background: rgba(128, 128, 128, 0.108);
}
.el-textarea.is-disabled /deep/ .el-textarea__inner {
  color: rgba(0, 0, 0, 0.672);
  background: rgba(128, 128, 128, 0.108);
}
/deep/ .el-input.is-disabled .el-input__inner {
  color: rgba(0, 0, 0, 0.672);
  background: rgba(128, 128, 128, 0.108);
}
.el-row{
    display:flex;
    flex-wrap: wrap;
}
</style>